package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.model.pages.CompanyResponsiblePerson
import com.example.mystybag.appCore.model.pages.CompanyResponsiblePersonsListUIState
import com.example.mystybag.common.resources.SR
import com.example.mystybag.communication.common.CommonCommands
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_MERCHANT_ID
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.sharedmodels.project.requestModels.merchant.GetMerchantMenuDataRequestModel
import kotlinx.coroutines.launch

class CompanyResponsiblePersonsListViewModel(
    context: AppContext
) : ChildViewModel<CompanyResponsiblePersonsListUIState>(context, CompanyResponsiblePersonsListUIState()) {

    override fun onCreate() {
        navControls.backButtonVisible = true
        navControls.title = sharedString(SR.strings.company_responsible_persons)
        loadPersons()
    }

    override fun onResume() {
        loadPersons()
    }

    private fun loadPersons() {
        val merchantId = Preferences.getLong(key = PREFERENCES_MERCHANT_ID, 0L)
        if (merchantId == 0L) {
            updateState { it.copy(isLoading = false) }
            return
        }
        scope.launch {
            updateState { it.copy(isLoading = true) }
            commandBlock(showProgress = false, hideProgress = false) {
                CommonCommands.getMerchantMenuData(
                    GetMerchantMenuDataRequestModel(merchantId = merchantId)
                )
                    .onResponse(
                        success = { response ->
                            launchOnMain {
                                val responseModel = response as? com.example.mystybag.sharedmodels.project.responseModels.merchant.GetMerchantMenuDataResponseModel
                                val persons = responseModel?.companyResponsiblePersons?.map { person ->
                                    CompanyResponsiblePerson(
                                        id = person.id ?: 0L,
                                        firstName = person.firstName ?: "",
                                        lastName = person.lastName ?: "",
                                        phoneNumber = person.phoneNumber ?: "",
                                        dialCode = person.dialCode ?: ""
                                    )
                                } ?: emptyList()
                                updateState {
                                    it.copy(
                                        isLoading = false,
                                        persons = persons
                                    )
                                }
                            }
                        },
                        baseError = {
                            launchOnMain {
                                updateState { it.copy(isLoading = false) }
                            }
                        }
                    )
            }
        }
    }

    fun navigateToEditPerson(personId: Long) {
        navigate(com.example.mystybag.appCore.logic.NavigatorCompanyResponsiblePersonEdit(personId = personId))
    }
}
